import { cn } from "../../lib/utils";

const Or = ({ className }: { className?: string }) => {
    return (
        <div className={cn("flex justify-center items-center py-2", className)}>
            <hr className="bg-slate-300 w-full h-[1.5px]" />
            <p className="px-4 text-slate-500 dark:text-slate-300">OR</p>
            <hr className="bg-slate-300 w-full h-[1.5px]" />
        </div>
    );
};

export default Or;
